/**
 * 成就图标映射。
 *
 * 后端只返回图标「键」（如 graduationCap），这里映射到按需引入的 Font Awesome 图标定义，
 * 交给 FaIcon 组件渲染成内联 svg。
 *
 * ⚠️ 必须走子路径引入（@fortawesome/free-solid-svg-icons/faXxx），
 * 否则会把 2000+ 个图标全打进包里。
 */
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook'
import { faBookOpen } from '@fortawesome/free-solid-svg-icons/faBookOpen'
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap'
import { faBrain } from '@fortawesome/free-solid-svg-icons/faBrain'
import { faInfinity } from '@fortawesome/free-solid-svg-icons/faInfinity'
import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon'
import { faCloudMoon } from '@fortawesome/free-solid-svg-icons/faCloudMoon'
import { faBed } from '@fortawesome/free-solid-svg-icons/faBed'
import { faSun } from '@fortawesome/free-solid-svg-icons/faSun'
import { faBullseye } from '@fortawesome/free-solid-svg-icons/faBullseye'
import { faChartLine } from '@fortawesome/free-solid-svg-icons/faChartLine'
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons/faCalendarCheck'
import { faSeedling } from '@fortawesome/free-solid-svg-icons/faSeedling'
import { faFire } from '@fortawesome/free-solid-svg-icons/faFire'
import { faCrown } from '@fortawesome/free-solid-svg-icons/faCrown'
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus'
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers'
import { faHandshake } from '@fortawesome/free-solid-svg-icons/faHandshake'
import { faFaceSmile } from '@fortawesome/free-solid-svg-icons/faFaceSmile'
import { faComments } from '@fortawesome/free-solid-svg-icons/faComments'
import { faComment } from '@fortawesome/free-solid-svg-icons/faComment'
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp'
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart'
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar'
import { faMedal } from '@fortawesome/free-solid-svg-icons/faMedal'
import { faTrophy } from '@fortawesome/free-solid-svg-icons/faTrophy'
import { faMask } from '@fortawesome/free-solid-svg-icons/faMask'
import { faBolt } from '@fortawesome/free-solid-svg-icons/faBolt'
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion'

/** 图标键 → FA 图标定义。 */
const ACHIEVEMENT_ICONS = {
  book: faBook,
  bookOpen: faBookOpen,
  graduationCap: faGraduationCap,
  brain: faBrain,
  infinity: faInfinity,
  moon: faMoon,
  cloudMoon: faCloudMoon,
  bed: faBed,
  sun: faSun,
  bullseye: faBullseye,
  chartLine: faChartLine,
  calendarCheck: faCalendarCheck,
  seedling: faSeedling,
  fire: faFire,
  crown: faCrown,
  userPlus: faUserPlus,
  users: faUsers,
  handshake: faHandshake,
  faceSmile: faFaceSmile,
  comments: faComments,
  comment: faComment,
  thumbsUp: faThumbsUp,
  heart: faHeart,
  star: faStar,
  medal: faMedal,
  trophy: faTrophy,
  mask: faMask,
  bolt: faBolt,
  question: faQuestion
}

/** 兜底图标。 */
const DEFAULT_ACHIEVEMENT_ICON = faMedal

/**
 * 按键取图标定义，未知键回退奖牌。
 *
 * @param {string} key 图标键
 * @returns {Object} FA 图标定义
 */
export function resolveAchievementIcon(key) {
  return ACHIEVEMENT_ICONS[key] || DEFAULT_ACHIEVEMENT_ICON
}
